module.exports = __webpack_public_path__ + "static/media/22770051_1629539363787915_5580874777198240131_o.d3632b29.jpg";